import FeedbackCard from "../../components/FeedbackCard";
import { clientData } from "../../utils/constants";
import { Carousel } from "@mantine/carousel";
import { motion } from "framer-motion";

const Feedback = () => {
  const data = clientData;

  console.log('Feedback data:', data.length, 'items');

  return (
    <section
      className="relative bg-gradient-to-br from-neutral-950 via-neutral-900 to-neutral-950 overflow-hidden px-3 400:px-4 500:px-p83 pt-8 500:pt-10 700:pt-12 900:pt-14 pb-6 500:pb-8 700:pb-10 900:pb-14 min-h-[90vh] flex flex-col justify-center w-full"
      style={{
        backgroundImage: 'radial-gradient(circle at 20% 50%, rgba(0, 120, 209, 0.1), transparent 50%), radial-gradient(circle at 80% 80%, rgba(255, 164, 56, 0.08), transparent 50%)'
      }}
      id="testimonials"
    >
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-72 h-72 bg-primary-200/20 rounded-full blur-3xl -translate-y-1/2 pointer-events-none" style={{ left: '-144px' }} />
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-accent-orange/10 rounded-full blur-3xl translate-y-1/2 pointer-events-none" style={{ right: '-192px' }} />

      <div className="relative z-10 max-w-7xl mx-auto w-full">
        {/* Header Section */}
        <motion.div
          className="text-center mb-8 500:mb-10 relative z-20"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-50px" }}
          transition={{ duration: 0.6 }}
        >
          <motion.div
            className="inline-flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-primary-500/20 to-primary-600/10 border border-primary-500/30 rounded-full mb-4 backdrop-blur-sm"
            initial={{ opacity: 0, scale: 0.8 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <span className="w-2 h-2 bg-primary-400 rounded-full animate-pulse" />
            <span className="text-primary-300 font-poppins-semi-bold text-sm">
              Client Testimonials
            </span>
          </motion.div>

          <h2 className="font-merry-bold tracking-tight text-2xl 500:text-3xl 700:text-4xl 900:text-5xl mb-3">
            What Our{" "}
            <span className="relative inline-block">
              <span className="relative z-10 text-primary-500 font-bold">
                Clients Say
              </span>
              <motion.span
                className="absolute bottom-2 left-0 right-0 h-3 bg-primary-500/20 -z-0 rounded-full"
                initial={{ width: 0 }}
                whileInView={{ width: "100%" }}
                viewport={{ once: true }}
                transition={{ duration: 0.8, delay: 0.3 }}
              />
            </span>
          </h2>

          <motion.p
            className="text-neutral-300 text-sm 500:text-base max-w-2xl mx-auto font-poppins-regular"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            Don't just take our word for it. Here's what our satisfied clients
            have to say about working with us.
          </motion.p>
        </motion.div>

        {/* Carousel Section */}
        <motion.div
          className="w-full py-2 500:py-4 relative"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <div className="relative w-full">
            <Carousel
              slidesToScroll={1}
              slideSize={{ base: "100%", sm: "90%", md: "45%", lg: "38%", xl: "33%" }}
              slideGap="md"
              controlSize={40}
              align="start"
              loop={data.length > 3}
              dragFree
              withIndicators={true}
              withControls={true}
              styles={{
                root: {
                  overflow: "hidden",
                  width: "100%",
                },
                viewport: {
                  overflow: "hidden",
                  paddingBottom: "0.5rem",
                  paddingTop: "0",
                },
                container: {
                  overflow: "hidden",
                },
                slide: {
                  padding: "0.5rem",
                },
                controls: {
                  top: "50%",
                  transform: "translateY(-50%)",
                  zIndex: 20,
                },
                indicators: {
                  bottom: "-1.5rem",
                  zIndex: 10,
                },
                indicator: {
                  width: "8px",
                  height: "8px",
                  backgroundColor: "rgba(55, 65, 81, 0.5)",
                  border: "1px solid rgba(0, 120, 209, 0.3)",
                  "&[data-active]": {
                    backgroundColor: "rgba(0, 120, 209, 0.8)",
                    borderColor: "rgba(0, 120, 209, 0.6)",
                  },
                },
                control: {
                  backgroundColor: "rgba(31, 41, 55, 0.9)",
                  border: "2px solid rgba(0, 120, 209, 0.4)",
                  color: "rgb(96, 165, 250)",
                  backdropFilter: "blur(8px)",
                  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.4)",
                  "&:hover": {
                    backgroundColor: "rgba(0, 120, 209, 0.2)",
                    borderColor: "rgba(0, 120, 209, 0.5)",
                    color: "rgb(59, 130, 246)",
                  },
                },
              }}
            >
            {data && data.length > 0 ? (
              data.map(({ _id, Name, company, description, image, position }, index) => (
                <Carousel.Slide key={_id}>
                  <div className="h-full">
                    <FeedbackCard
                      image={image}
                      username={Name}
                      company={company}
                      position={position}
                      content={description}
                    />
                  </div>
                </Carousel.Slide>
              ))
            ) : (
              <div className="text-center py-12">
                <p className="font-poppins-semi-bold text-xl text-neutral-500">
                  No testimonials available
                </p>
              </div>
            )}
          </Carousel>
          </div>
        </motion.div>

        {/* Stats Section */}
        <motion.div
          className="grid grid-cols-2 500:grid-cols-4 gap-3 500:gap-4 700:gap-6 mt-6 500:mt-8 700:mt-10 900:mt-12 mb-0"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
        >
          {[
            { value: "100+", label: "Happy Clients" },
            { value: "4.9/5", label: "Average Rating" },
            { value: "98%", label: "Satisfaction Rate" },
            { value: "50+", label: "Projects Delivered" },
          ].map((stat, index) => (
            <motion.div
              key={index}
              className="text-center p-3 500:p-4 700:p-6 bg-gradient-to-br from-neutral-800/80 to-neutral-900/80 backdrop-blur-md rounded-xl 500:rounded-2xl border border-neutral-700/50 shadow-lg hover:shadow-xl hover:border-primary-500/30 transition-all duration-300"
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: 0.5 + index * 0.1 }}
              whileHover={{ y: -4, scale: 1.02 }}
            >
              <p className="text-xl 500:text-2xl 700:text-3xl font-poppins-bold bg-gradient-to-r from-primary-400 to-primary-500 bg-clip-text text-transparent mb-1 500:mb-1.5">
                {stat.value}
              </p>
              <p className="text-xs 500:text-sm 700:text-base font-poppins-regular text-neutral-300">
                {stat.label}
              </p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Feedback;
